export default __webpack_public_path__ + "static/media/checkbox-selected.a31041f2.svg";